import React from "react"
import { Switch, Route } from "react-router-dom"

import Main from "../pages"

const Routes = () => (
	<Switch>
		<Route path="/:hash" component={Main} />
	</Switch>
)

export default Routes
